import { createFileRoute } from "@tanstack/react-router";
import { ApiKeysSettings } from "@/components/settings/api-keys-settings";
import { redirectIfModuleDisabled } from "@/lib/module-guards";

export const Route = createFileRoute("/_authorized/team/settings/api-keys")({
	beforeLoad: () => redirectIfModuleDisabled("public_api"),
	component: ApiKeysSettings,
});
